import { lazy, Suspense } from 'react';

import { ROUTES } from 'App/Routes/constants';
import { Route } from 'react-router-dom';

import { DashboardProvider } from 'commons/utils/hooks/useDashboardContext';
import { FiltersProvider } from 'commons/utils/hooks/useFilters';

import Loading from 'domains/widgets/loading';

import { ExternalShipmentsProvider } from './context';

const SaveOnShipping = lazy(() => import('domains/orders/save-on-shipping'));

const SaveOnShippingRoute = (
  <Route
    path={ROUTES.SAVE_ON_SHIPPING}
    element={
      <Suspense fallback={<Loading />}>
        <FiltersProvider>
          <DashboardProvider>
            <ExternalShipmentsProvider>
              <SaveOnShipping />
            </ExternalShipmentsProvider>
          </DashboardProvider>
        </FiltersProvider>
      </Suspense>
    }
  />
);

export default SaveOnShippingRoute;
